import { useFieldArray } from "react-hook-form";
import {
  IconButton,
  Stack,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material";
import { useSnackbar } from "../../../../components/minimal/snackbar";
import {
  RHFRoundedTextField,
  RHFUpload,
} from "../../../../components/minimal/hook-form";
import Iconify from "../../../../components/minimal/iconify";
import { IFormProps } from "types/form-props";

interface QuestionFormProps extends IFormProps {}

const QuestionForm: React.FC<QuestionFormProps> = ({
  currentItem,
  setValue,
  control,
}) => {
  const questionId = currentItem?.id;
  const { enqueueSnackbar } = useSnackbar();
  const isUpdate = !!currentItem;

  var { fields, append, remove } = useFieldArray({
    control: control,
    name: "answers",
  });

  const handleCorrectAnswerChange = (index: number) => {
    setValue(`answers[${index}].correctAnswer` as any, true);
    // fields[index].correctAnswer = true;
    fields.forEach((option: any, idx) => {
      if (idx !== index && option.correctAnswer === true) {
        setValue(`answers[${idx}].correctAnswer` as any, false);
        // fields[idx].correctAnswer = false;
      }
    });
    remove(100);
  };

  const renderAnswerFields = () => {
    return fields.map((answer: any, index) => (
      <Stack
        key={answer.id}
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ mt: 3 }}
      >
        <RHFRoundedTextField
          name={`answers[${index}].answerText`}
          label={`Answer ${index + 1}`}
          disabled={isUpdate} // Disable the text field when isUpdate is true
        />

        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              disabled={isUpdate} // Disable the checkbox when isUpdate is true
              checked={answer.correctAnswer} // Set checked state to the current correct answer value
              onClick={(e) => {
                // Prevent click event when isUpdate is true
                if (isUpdate) {
                  e.preventDefault();
                  return;
                }
                handleCorrectAnswerChange(index);
              }}
            />
          }
          label="Correct"
        />

        {!isUpdate && (
          <IconButton
            onClick={(e) => {
              if (!answer.correctAnswer) {
                remove(index);
              } else {
                enqueueSnackbar(`Can't remove the correct answer`, {
                  variant: "error",
                });
              }
            }}
            sx={{
              backgroundColor: "#FF922E",
              "&:hover": { backgroundColor: "#FF7F00" },
            }}
          >
            <Iconify icon={"solar:trash-bin-trash-bold"} color="white" />
          </IconButton>
        )}
      </Stack>
    ));
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            fontSize: "11pt",
          }}
        >
          Question Image
        </Typography>
        <RHFUpload
          name="questionImage"
          onDrop={(acceptedFiles) => {
            const newFile = Object.assign(acceptedFiles[0], {
              preview: URL.createObjectURL(acceptedFiles[0]),
            });
            setValue("questionImage", newFile);
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <RHFRoundedTextField
          name="questionText"
          label="Question Text"
          disabled={isUpdate}
        />
        {renderAnswerFields()}
        {!isUpdate && (
          <Button
            onClick={() =>
              append({
                answerQuestion: questionId,
                answerText: "",
                correctAnswer: false,
              })
            }
            sx={{ mt: 3, width: "100%" }}
          >
            Add Answer
          </Button>
        )}
      </Grid>
    </>
  );
};
export default QuestionForm;
